<template>
	<div>
		<el-form :inline="true" size="mini" :model="pages" :class="lang=='cn'?'':'on'">
			<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
				<el-date-picker v-model="pages.date" clearable value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')" style="width: 300px;"></el-date-picker>
			</el-form-item>
			<el-form-item :label="$t('course_index.year')" prop="date" data-name="年度">
				<el-date-picker v-model="pages.year" type="year" value-format="yyyy" :placeholder="$t('index.select')"></el-date-picker>
			</el-form-item>
			<el-form-item :label="$t('course_index.theme')" prop="keyword" data-name="主题">
				<el-input v-model="pages.keyword" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<el-form-item label="ID" prop="ID" data-name="id">
				<el-input v-model="pages.id" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="mini" @click="search()">{{$t('index.search')}}</el-button>
				<el-button type="primary" size="mini" @click="reset()">{{$t('index.reset')}}</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="list" size="mini" border @sort-change="sort_change">
			<el-table-column prop="id" align="center" label="ID" data-name="id" width="60"></el-table-column>
			<el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('course_index.theme')" data-name="主题" width="120"></el-table-column>
			<el-table-column prop="start_date" align="center" :label="$t('course_index.date')" data-name="日期" width="100">
				<template slot-scope="{row}"><p>{{getTime_us(row.start_date,'mmddyyyy')}}</p><p>{{getTime_us(row.end_date,'mmddyyyy')}}</p></template>
			</el-table-column>
			<el-table-column prop="week" align="center" :label="$t('course_index.week')" data-name="星期">
				<template slot-scope="{row}">{{getTime_week(row.have_date_time)}}</template>
			</el-table-column>
			<el-table-column prop="start_time" align="center" :label="$t('course_index.time')" data-name="时间" width="90">
				<template slot-scope="{row}"><p>{{getTime_us(row.start_time,'hh:ii')}}</p> <p>{{getTime_us(row.end_time,'hh:ii')}}</p></template>
			</el-table-column>
			<el-table-column prop="max_people" align="center" :label="$t('course_index.max_people')" data-name="班级规模"  sortable="custom" width="110"></el-table-column>
			<el-table-column prop="age" align="center" :label="$t('course_index.age')" data-name="年龄" width="70">
				<template slot-scope="{row}">{{row.min_age}}-{{row.max_age}}y</template>
			</el-table-column>
			<el-table-column prop="price" align="center" :label="$t('course_index.price')" data-name="学费"></el-table-column>
			<el-table-column prop="class_num" align="center" :label="$t('course_index.class_num')" data-name="总课次" width="80"></el-table-column>
			<el-table-column prop="create_time" align="center" :label="$t('course_index.create_time')" data-name="时间">
				<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyy')}}</template>
			</el-table-column>
			<el-table-column prop="remarks" align="center" :label="$t('feedback_index.remarks')" data-name="备注"></el-table-column>
			<el-table-column prop="create_time" align="center" :label="$t('course_index.status')" data-name="状态">
				<template slot-scope="{row}">{{row.status>1?$t('course_index.upcoming'):$t('course_index.ongoing')}}</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="100">
				<template slot-scope="{row}">
					<el-button size="mini" type="primary" @click="determine(row)" data-name="编辑">{{$t('index.determine')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination :total="pages.count" :page.sync="pages.page" :limit.sync="pages.perpage" @pagination="init" />
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			pages: {
				date:[],
				page: 1,
				count: 0,
				perpage: 10,
				year:'',
				keyword:'',
				id:'',
			},
		}
	},
	mounted () {
		this.init();
	},
	methods: {
		init: function () {
			var this_ = this;
			var url = "courseRemoteList"
			var datas = {
				...this.pages,
				num: this.pages.perpage,
			}
			if (this.pages.date&&this.pages.date.length>0) {
				datas['start_date']=this.pages.date[0]/1000;
				var time=(24*60*60-1)*1000;
				datas['end_date']=(this.pages.date[1]+time)/1000;
			}else if(this.pages.year){
				var start_date = Math.round(new Date(this.pages.year,0,1,0,0,0).getTime()/1000);
				var end_date = Math.round(new Date(this.pages.year,11,31,23,59,59).getTime()/1000);
				datas['start_date']=start_date;
				datas['end_date']=end_date;
				delete datas.year;
			}
			this.$post(url, datas).then((res) => {
				this.list = res.list;
				this.pages.count = res.sum;
			})
		},
		search() {
			this.pages.page = 1;
			this.init();
		},
		reset() {
			this.pages = this.$options.data().pages;
			this.init();
		},
		sort_change(data){
			this.pages.sort_filed=data.prop;
			if (data.order=="ascending") {
				this.pages.sort_type='desc';
			}else if(data.order=="descending"){
				this.pages.sort_type='asc';
			}else {
				this.pages.sort_type='';
			}
			this.init();
		},
		determine(data){
			this.$emit("callback",data.id);
		}
	}
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/courseRemoteList.vue